import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { PageHeader, Loader } from "../../components";
import { useAxios, useComponent } from "../../hooks";
import pages from "../../constants/pages";
import Table from "./list components/Table";

export default function ReminderBroadcastList({ pageID }) {
  const axios = useAxios();
  const { activeBot } = useSelector((state) => state.memberDetails);
  const { loader } = useComponent({ pageID });

  const [broadcasts, setBroadcasts] = useState([]);

  useEffect(() => {
    loader.start(1);
    axios({
      url: "/reminders/" + activeBot.ID + "?skip=0&limit=50",
      method: "GET",
    }).then((response) => {
      if (response.status) {
        setBroadcasts(response.data);
        loader.apiComplete(1);
      } else {
        loader.apiComplete(1);
      }
    });
  }, [axios, activeBot, loader]);

  return (
    <Loader>
      <PageHeader
        pageName="Reminder Broadcasts"
        addIcon={[
          "Create Reminder Broadcast",
          pages.createReminderBroadcast.route,
          true,
        ]}
      />

      <Table broadcasts={broadcasts} />
    </Loader>
  );
}
